import React, { useEffect, useState } from "react";
import "../../_css/ReviewAns.css";
import QASheet from "./QASheet";
import AIEval from "./AIEval";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { useNavigate, useParams } from "react-router-dom";
import { getAllPdfs } from "../../requests";
import { deleteAuthToken } from "../../utils/helper";
import { notifyError } from "../helper/Toaster";
import SearchableDropdown from "../common/SearchableDropdown";

const ReviewAnsPopUp = ({ id, fn }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [view, setView] = useState("default");
  const [showMemo, setShowMemo] = useState(false);
  const [showfd, setShowfd] = useState(false);
  const [question, setquestion] = useState("");
  const [Student, setStudent] = useState("John");
  const [aiEvalId, setAiEvalId] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [questions, setQuestions] = useState([
    { id: 0, question: "All Questions" },
  ]);

  const [pdfs, setAllPdfs] = useState("");

  const handleBtn = async () => {
    if (view == "pdf") {
      setShowMemo(!showMemo);
      return;
    }

    setShowfd(!showfd);
  };

  const handle_drp = (e) => {
    setquestion(e);

    if (e == "All Questions") {
      setView("default");
      setAiEvalId(0);
      return;
    }

    let id = questions.find((el) => el.question == e)?.id;

    if (id) {
      setAiEvalId(id);
      setView("eval");
    }
  };

  const get_pdf = async () => {
    dispatch(startLoader());

    try {
      const res = await getAllPdfs({ id: id });
      // console.log(res.data.data);

      setAllPdfs(res.data.data);
      setStudent(res.data.data.student_name);
    } catch (error) {
      console.log(error);
      if (error?.response?.status == 403) {
        deleteAuthToken();

        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );

        navigate("/login");

        return;
      }
      notifyError(error.response?.data?.error || "Error fetching files");
    } finally {
      dispatch(stopLoader());
    }
  };

  useEffect(() => {
    get_pdf();
  }, [id, refresh]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
        // padding: "2vh 0",
        overflowY: "auto",
       
      }}
    >
      <div className="review-main" style = {{width:'75%', justifySelf:'center'}}>
        {/* <div className="review-head">
        <div className="review-head-left">
          <div
            onClick={() =>
              view != "default" &&  (setView("default"), setquestion('All Questions')) 
            }
            className="review-head-text"
            style={{
              color: view != "pdf" ? "#FFFFFF" : "#030712",
              backgroundColor: view != "pdf" && "#01A7DE",
            }}
          >
            Default View
          </div>
          <div
            onClick={() => (view != "pdf" && setView("pdf"))}
            className="review-head-text"
            style={{
              color: view == "pdf" ? "#FFFFFF" : "#030712",
              backgroundColor: view == "pdf" ? "#01A7DE" : "",
            }}
          >
            PDF View
          </div>
        </div>
       
        <button onClick={handleBtn} className="review-head-btn">
          {view == "pdf"
            ? showMemo
              ? "Hide Answer Memo"
              : "Show Answer Memo"
            : "Generate Feedback"}
        </button>
      </div> */}

        <div className="review-student">
          {/* VIEW IS EMPTY */}
          {view == "default" && (
            <>
              <div className="review-student-head">
                <div className="review-student-text">
                  {Student} &nbsp;&nbsp;
                  {/* <span style={{ fontWeight: "200", fontSize: "16px" }}>
                  &gt;
                </span> */}
                </div>
                <div
                  className="review-student-text"
                  style={{ fontSize: "18px" }}
                >
                  Total Marks : {pdfs?.marks_obt}/{pdfs?.marks_total}
                </div>
                {/* <div style={{ width: "20%" }}>
                  <SearchableDropdown
                    options={questions.map((e) => e.question)}
                    selected={question}
                    setSelected={handle_drp}
                    allowManualEntry={false}
                    color="#E5E7EB"
                  />
                </div> */}
                <img src="/close.svg"  onClick={fn} style={{width:'18px', height:'18px', cursor:'pointer'}} />
              </div>

              <div style={{ width: "99%" }}>
                <QASheet
                  fn={(e, id) => (
                    setView("eval"), setquestion(e), setAiEvalId(id)
                  )}
                  refresh={refresh}
                  setQuestions={setQuestions}
                  aiEvalId={aiEvalId}
                  id={id}
                />
              </div>
            </>
          )}

          {/* VIEW IS DEFAULT */}
          {view == "eval" && (
            <>
              <div className="review-student-head">
                <div className="review-student-text">
                  {Student}
                  {/* <span style={{ fontWeight: "200", fontSize: "16px" }}>
                  &gt;
                </span> */}
                </div>
                <div
                  className="review-student-text"
                  style={{ fontSize: "18px" }}
                >
                  Total Marks : {pdfs?.marks_obt}/{pdfs?.marks_total}
                </div>
                <div style={{ width: "20%" }}>
                  {/* <SearchableDropdown
                    options={questions.map((e) => e.question)}
                    selected={question}
                    setSelected={handle_drp}
                    allowManualEntry={false}
                    color="#E5E7EB"
                  /> */}
                </div>
                <img src="/close.svg"  onClick={fn} style={{width:'18px', height:'18px', cursor:'pointer'}} />
              </div>

              <div style={{ width: "99%", display: "flex" }}>
                <div style={{ width: "70%" }}>
                  <QASheet
                    fn={(e, id) => (
                      setView("eval"), setquestion(e), setAiEvalId(id)
                    )}
                    refresh={refresh}
                    setQuestions={setQuestions}
                    aiEvalId={aiEvalId}
                    id={id}
                  />
                </div>
                <AIEval
                  id={aiEvalId}
                  fn={() => (
                    setView("default"),
                    setquestion("All Questions"),
                    setAiEvalId(0)
                  )}
                  setRefresh={setRefresh}
                  refresh={refresh}
                />
              </div>
            </>
          )}

         
        </div>
      </div>
    </div>
  );
};

export default ReviewAnsPopUp;
